export default __webpack_public_path__ + "static/media/poster.36b76b59.png";